import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/roles",
)({
  staticData: {
    breadcrumb: [
      { label: "Workspace - Roles", href: "/settings/workspace/roles" },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "roles:read", "/settings/workspace/general"),
})
